import Vue from 'vue'
import App from './App.vue'
// eslint-disable-next-line no-unused-vars
import animate from 'animate.css'
import 'ant-design-vue/dist/antd.css';
import Directive  from './index.js'

import Antd from 'ant-design-vue';


Vue.use(Antd);

Directive(Vue)
Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
